import { __extends } from "tslib";
import { deserializeAws_json1_1GetLabelDetectionCommand, serializeAws_json1_1GetLabelDetectionCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetLabelDetectionCommand = /** @class */ (function (_super) {
    __extends(GetLabelDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLabelDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetLabelDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLabelDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetLabelDetectionCommand(input, context);
    };
    GetLabelDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetLabelDetectionCommand(output, context);
    };
    return GetLabelDetectionCommand;
}($Command));
export { GetLabelDetectionCommand };
//# sourceMappingURL=GetLabelDetectionCommand.js.map